export const REIMBURSEMENT_LOADING = "REIMBURSEMENT_LOADING";
export const REIMBURSEMENT_RESET = "REIMBURSEMENT_RESET";
export const GET_REIMBURSEMENT = "GET_REIMBURSEMENT";
export const GET_REIMBURSEMENT_SUCCESS = "GET_REIMBURSEMENT_SUCCESS";
export const GET_REIMBURSEMENT_FAIL = "GET_REIMBURSEMENT_FAIL";
export const DELETE_REIMBURSEMENT = "DELETE_REIMBURSEMENT"
export const DELETE_REIMBURSEMENT_SUCCESS = "DELETE_REIMBURSEMENT_SUCCESS"
export const DELETE_REIMBURSEMENT_FAIL = "DELETE_REIMBURSEMENT_FAIL"
export const UPDATE_REIMBURSEMENT = "UPDATE_REIMBURSEMENT"
export const UPDATE_REIMBURSEMENT_SUCCESS = "UPDATE_REIMBURSEMENT_SUCCESS"
export const UPDATE_REIMBURSEMENT_FAIL = "UPDATE_REIMBURSEMENT_FAIL"
export const ADD_NEW_REIMBURSEMENT = "ADD_NEW_REIMBURSEMENT"
export const ADD_REIMBURSEMENT_SUCCESS = "ADD_REIMBURSEMENT_SUCCESS"
export const ADD_REIMBURSEMENT_FAIL = "ADD_REIMBURSEMENT_FAIL"